import ExpandLessRoundedIcon from '@material-ui/icons/ExpandLessRounded';
import ExpandMoreRoundedIcon from '@material-ui/icons/ExpandMoreRounded';
import React from 'react';
import styled, { css } from 'styled-components/macro';
import { ItemInstructions } from '../../student/elements/Home';
import {
  focusRing,
  layout,
  media,
  radius,
  shadow,
  space,
  transition,
} from '../../../theme/tokens';

const iconButton = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  min-width: ${layout.touchTarget};
  min-height: ${layout.touchTarget};
  padding: 0;
  border: none;
  border-radius: ${radius.pill};
  background: none;
  color: ${({ theme }) => theme.textDark};
  cursor: pointer;
  transition: background ${transition.fast};
  &:hover {
    background: ${({ theme }) => theme.hoverFill};
  }
  ${focusRing}
`;

export const EvidenceTargetContainer = styled.section`
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 20;
  background: ${({ theme }) => theme.appBackground};
  display: flex;
  flex-direction: column;

  ${({ isStaff }) =>
    !isStaff &&
    css`
      ${media.md`
        width: calc(100vw - ${layout.sidebarWidth});
      `}
    `};

  ${({ isStaff }) =>
    isStaff &&
    css`
      ${media.md`
        width: auto;
      `}
    `};
`;

export const CloseButton = styled.button`
  ${iconButton}
  align-self: flex-start;
`;

export const ShowButton = styled.button`
  ${iconButton}
  align-self: flex-start;
`;

export const ShowIcon = () => {
  return <ExpandMoreRoundedIcon style={{ fontSize: '3.5rem' }} />;
};

export const HideIcon = () => {
  return <ExpandLessRoundedIcon style={{ fontSize: '3.5rem' }} />;
};

export const ChatBackground = styled.div`
  background: ${({ theme }) => theme.chatBackground};
  display: flex;
  justify-content: space-between;
  gap: ${space[1]};
  padding: ${space[2]};
  box-shadow: ${shadow.md};
`;

export const TargetEvidenceHeaderRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${space[3]};
  margin: ${space[5]} ${layout.gutter};
  text-align: center;
`;

export const ScrollSection = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: scroll;
`;

export const TaskInstructions = styled(ItemInstructions).attrs({ as: 'li' })`
  margin: ${space[3]} 0;
`;

export const SelectContainer = styled.div`
  padding: 0 ${layout.gutter};
  ${media.md`
    padding: 0 ${layout.gutterWide};
  `}
`;

export * from '../../common/elements/Staff';
export * from '../../student/elements/PersonalTarget.js';
